import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { useAuthState } from '@/hooks/AuthContext';
import { AssetsConfig } from '@/services/AssetsConfig';


const WelcomePage = () => {
    const navigate = useNavigate();
    const { login, register } = useKindeAuth();
    const { isAuthenticated, isLoading } = useAuthState(); // Use the centralized auth state

    useEffect(() => {
        if (!isLoading && isAuthenticated) {
            navigate('/projects');
        }
    }, [isAuthenticated, isLoading, navigate]);

    if (isLoading) {
        return <div>Loading...</div>;
    }

    // Only render the welcome page content if not authenticated
    if (!isAuthenticated) {
        return (
            <div className="min-h-screen flex flex-col"
            style={{
                backgroundImage: "url('https://gni-public-bucket.s3.us-east-1.amazonaws.com/dashboard_images/welcome_page_background.png')",
                backgroundSize: '100% auto'
            }}>
                {/* Header - Fixed */}
                {/* <header className="fixed top-0 left-0 right-0 p-4 flex justify-between items-center bg-white z-50 shadow-md"> */}

                {/* <header className="fixed top-0 left-0 right-0 h-16 px-4 flex justify-between items-center bg-white z-50 shadow-md">
                    <div className="flex items-center space-x-2 overflow-hidden">
                        <Link 
                                to={AssetsConfig.getLogoUrl().link} 
                                className="cursor-pointer hover:opacity-80 transition-opacity"
                        >   
                            <img 
                                src={AssetsConfig.getLogoUrl().logo_url}
                                alt="Logo"
                                className={`ml-2 mt-1 h-14 w-auto object-contain`}
                            />
                        </Link>
                    </div>
                    <div className="space-x-2 sm:space-x-4">
                        <Button onClick={login} variant="outline" className="text-sm sm:text-base">
                            Log in
                        </Button>
                        <Button
                            onClick={register}
                            className="bg-black text-white hover:bg-gray-800 text-sm sm:text-base"
                        >
                            Get started for free
                        </Button>
                    </div>
                </header> */}

                <header className="fixed top-0 left-0 right-0 h-12 sm:h-14 md:h-16 px-2 sm:px-3 md:px-4 flex justify-between items-center bg-white z-50 shadow-md">
                    <div className="flex items-center overflow-hidden">
                        <Link 
                        to={AssetsConfig.getLogoUrl().link} 
                        className="cursor-pointer hover:opacity-80 transition-opacity"
                        >   
                        <img 
                            src={AssetsConfig.getLogoUrl().logo_url}
                            alt="Logo"
                            className="h-8 sm:h-10 md:h-14 w-auto object-contain"
                        />
                        </Link>
                    </div>
                    <div className="flex items-center space-x-2 sm:space-x-3 md:space-x-4">
                        <Button 
                        onClick={login} 
                        variant="outline" 
                        className="text-xs sm:text-sm md:text-base px-2 sm:px-3 md:px-4 h-8 sm:h-9 md:h-10"
                        >
                        Log in
                        </Button>
                        <Button
                        onClick={register}
                        className="bg-black text-white hover:bg-gray-800 text-xs sm:text-sm md:text-base px-2 sm:px-3 md:px-4 h-8 sm:h-9 md:h-10"
                        >
                        Get started
                        </Button>
                    </div>
                </header>

                {/* Main content */}
                <main className="flex-grow flex flex-col lg:flex-row mt-16 "
                >
                    {/* Content */}
                    <div className="w-full lg:w-1/2 p-6 sm:p-12 flex flex-col justify-center lg:bg-opacity-100 mt-[20vh] lg:mt-4 relative z-10 lg:min-h-screen"
                    style={{
                        backgroundImage: "url('https://gni-public-bucket.s3.us-east-1.amazonaws.com/dashboard_images/welcome_page_book.png')",
                        backgroundSize: '100% auto',
                        backgroundRepeat: 'no-repeat'
                    }}
                    
                    >

                        <div className="ml-20 mr-4 sm:ml-28 lg:ml-28 max-w-2xl">
                            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
                                Create Your Project Portfolio
                            </h1>
                            <p className="text-lg sm:text-xl mb-8">Build a comprehensive digital portfolio of your kitchen or bath project</p>
                            <div className="space-y-4 mb-8">

                                <Button onClick={register} className="w-full bg-blue-500 hover:bg-blue-600 text-white">
                                    Start Your Project
                                </Button>
                                <Button onClick={login} className="w-full bg-gray-500 hover:bg-gray-600 text-white">
                                    Continue Project
                                </Button>
                                
                            </div>
                        </div>
                    </div>

                    {/* Image container */}
                    <div className="w-full lg:w-1/2 h-[50vh] lg:h-auto lg:min-h-screen fixed lg:static top-16 left-0 right-0 z-0 p-4 lg:p-8">
                        {/* Image with padding and rounded corners */}
                        <div
                            className="w-full h-full rounded-2xl bg-cover bg-center"
                            style={{
                                backgroundImage:
                                    "url('https://gni-public-bucket.s3.us-east-1.amazonaws.com/dashboard_images/Welcome+page+including+print+(2).png')",
                            }}
                        ></div>
                    </div>
                </main>
            </div>
        );
    }
    return null;
};

export default WelcomePage;
